import React from 'react';
import './LocationImage.less';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export const LocationImage = ({src, visibleByDefault}) => {
	return (
		<div className="location-image">
			<LazyLoadImage className="location-image__image" effect="opacity" src={src} visibleByDefault={visibleByDefault}/>
		</div>
	);
};
